import { render, staticRenderFns } from "./RequerimientoAttachmentsAdmin.vue?vue&type=template&id=03eed39a&scoped=true&"
import script from "./RequerimientoAttachmentsAdmin.vue?vue&type=script&lang=js&"
export * from "./RequerimientoAttachmentsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./RequerimientoAttachmentsAdmin.vue?vue&type=style&index=0&id=03eed39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eed39a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {
  VCheckbox,
  VDataTable,
  VFlex,
  VSwitch,
})
